import { ProfileData } from '../types'
import {
  getHabitTypeCountArray,
  ScoreCountChart,
} from '../components/ScoreCountChart'
import { getSessionKey, getProfileData } from '../api'
import { useEffect, useState } from 'react'
import _ from 'lodash'
import { habitTypes } from '../components/HabitsPanel'
import { Dialog } from '../components/Dialog'

export const Profile = ({
  playerId,
  onClose,
}: {
  playerId: string
  onClose: Function
}) => {
  const [profileData, setProfileData] =
    useState<undefined | ProfileData>(undefined)

  useEffect(() => {
    ;(async function () {
      setProfileData(await getProfileData(getSessionKey(), playerId))
    })()
  }, [playerId])

  return <ProfileContents profileData={profileData} onClose={onClose} />
}

export const ProfileContents = ({
  profileData,
  onClose,
}: {
  profileData?: ProfileData
  onClose: Function
}) => {
  if (!profileData) {
    return (
      <Dialog hasSubmitButton={false} onClose={onClose}>
        Loading...
      </Dialog>
    )
  } else {
    const { player, scores } = profileData

    const typeCountArray = getHabitTypeCountArray({ scores })
    const orderedTypeCountArray = _.orderBy(typeCountArray, (i) => i.count, [
      'desc',
    ])
    const bestHabitType = orderedTypeCountArray[0].habitType
    const worstHabitType =
      orderedTypeCountArray[habitTypes.length - 1].habitType

    return (
      <Dialog
        title={`🏆 ${player.firstName}'s Profile 🏆`}
        hasSubmitButton={false}
        closeText="Close"
        onClose={onClose}
      >
        <p>
          <div>
            💪 Habit they're crushing the most: {_.startCase(bestHabitType)}
          </div>
          <div>❤️ Habit needin' some love: {_.startCase(worstHabitType)}</div>
        </p>
        <ScoreCountChart scores={scores} />
      </Dialog>
    )
  }
}
